export default (context) => {

  const items = [
    {id: 4, name: 'Notas conducta', module:'admGradesBehavior', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 3, name: 'Comentarios del tutor', module:'admGradesBehavior', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 8, name: 'Por grupo', module:'admGradesBehavior', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
  ]

  const allowedItems = items.filter(f => { return !f.module || context.props.userAdmin.menu.some(s=> s.subs.some(ss=>ss.id === f.module))})

  return {
    config: {
      isBehavior: true
    },
    extras: {
      items: allowedItems
    }
  }
}